import React from 'react';
import { IconLetter, IconHelp } from '@klarna/bubble-ui';
import { ContractOnboardingStatus } from '@/bpc/mf-fields/enm/ContractOnboardingStatus';
export const SmallIcon = ({ status }) => {
    const Component = {
        [ContractOnboardingStatus.MANUAL_UNDERWRITING_INITIATED]: IconLetter,
        [ContractOnboardingStatus.ONBOARDING_COMPLETED]: IconHelp,
        [ContractOnboardingStatus.SUSPENDED]: IconHelp,
        [ContractOnboardingStatus.TERMINATED]: IconHelp,
    }[status || ''] || (() => React.createElement(React.Fragment, null));
    return React.createElement(Component, null);
};
